import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { AppLayout } from "@/components/layout/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Today from "@/pages/Today";
import CompanyHealth from "@/pages/CompanyHealth";
import FinancialOverview from "@/pages/FinancialOverview";
import Profitability from "@/pages/Profitability";
import CashIntelligence from "@/pages/CashIntelligence";
import ScenarioPlanner from "@/pages/ScenarioPlanner";
import Forecast from "@/pages/Forecast";
import Alerts from "@/pages/Alerts";
import Calendar from "@/pages/Calendar";
import Tasks from "@/pages/Tasks";
import Documents from "@/pages/Documents";
import Recommendations from "@/pages/Recommendations";
import Team from "@/pages/Team";
import Notifications from "@/pages/Notifications";
import Advisor from "@/pages/Advisor";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Navigate to="/app/today" replace />} />
            <Route path="today" element={<Today />} />
            <Route path="company" element={<CompanyHealth />} />
            <Route path="finance" element={<FinancialOverview />} />
            <Route path="profitability" element={<Profitability />} />
            <Route path="cash" element={<CashIntelligence />} />
            <Route path="plan" element={<ScenarioPlanner />} />
            <Route path="forecast" element={<Forecast />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="documents" element={<Documents />} />
            <Route path="recommendations" element={<Recommendations />} />
            <Route path="team" element={<Team />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="advisor" element={<Advisor />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AppProvider>
  );
}

export default App;
